import React from 'react';
import { LandingView } from '../components/public/LandingView';
import { AVA_LANDING } from '../data/avaLanding';
import { AVA_FORM } from '../data/avaForm';

/**
 * Landing pública principal del Sistema AVA (la web del propio producto).
 * Si existe una versión guardada en Supabase con el mismo slug, se usa esa;
 * si no, se muestra el contenido de marca por defecto.
 */
export function Home() {
  return <LandingView slug="sistema-ava" showAppNav fallback={{
    landing: AVA_LANDING,
    form: AVA_FORM
  }} data-id="element-1824" data-mp="1ziqwjsxh06od" />;
}